import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalGroceryStoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_grocery_store"}/>
}
